import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// ============================================================================
// English Translations (Base Language)
// ============================================================================
import commonEn from './locales/en/common.json' with { type: 'json' };
import notificationsEn from './locales/en/notifications.json' with { type: 'json' };
import settingsEn from './locales/en/settings.json' with { type: 'json' };
import navEn from './locales/en/nav.json' with { type: 'json' };
import pagesEn from './locales/en/pages.json' with { type: 'json' };
import mobileEn from './locales/en/mobile.json' with { type: 'json' };
// ============================================================================
// Afrikaans Translations
// ============================================================================
import commonAf from './locales/af/common.json' with { type: 'json' };
import notificationsAf from './locales/af/notifications.json' with { type: 'json' };
import settingsAf from './locales/af/settings.json' with { type: 'json' };
import navAf from './locales/af/nav.json' with { type: 'json' };
import pagesAf from './locales/af/pages.json' with { type: 'json' };
import mobileAf from './locales/af/mobile.json' with { type: 'json' };
// ============================================================================
// Arabic Translations
// ============================================================================
import commonAr from './locales/ar/common.json' with { type: 'json' };
import notificationsAr from './locales/ar/notifications.json' with { type: 'json' };
import settingsAr from './locales/ar/settings.json' with { type: 'json' };
import navAr from './locales/ar/nav.json' with { type: 'json' };
import pagesAr from './locales/ar/pages.json' with { type: 'json' };
import mobileAr from './locales/ar/mobile.json' with { type: 'json' };
// ============================================================================
// Catalan Translations
// ============================================================================
import commonCa from './locales/ca/common.json' with { type: 'json' };
import notificationsCa from './locales/ca/notifications.json' with { type: 'json' };
import settingsCa from './locales/ca/settings.json' with { type: 'json' };
import navCa from './locales/ca/nav.json' with { type: 'json' };
import pagesCa from './locales/ca/pages.json' with { type: 'json' };
import mobileCa from './locales/ca/mobile.json' with { type: 'json' };
// ============================================================================
// Czech Translations
// ============================================================================
import commonCs from './locales/cs/common.json' with { type: 'json' };
import notificationsCs from './locales/cs/notifications.json' with { type: 'json' };
import settingsCs from './locales/cs/settings.json' with { type: 'json' };
import navCs from './locales/cs/nav.json' with { type: 'json' };
import pagesCs from './locales/cs/pages.json' with { type: 'json' };
import mobileCs from './locales/cs/mobile.json' with { type: 'json' };
// ============================================================================
// Danish Translations
// ============================================================================
import commonDa from './locales/da/common.json' with { type: 'json' };
import notificationsDa from './locales/da/notifications.json' with { type: 'json' };
import settingsDa from './locales/da/settings.json' with { type: 'json' };
import navDa from './locales/da/nav.json' with { type: 'json' };
import pagesDa from './locales/da/pages.json' with { type: 'json' };
import mobileDa from './locales/da/mobile.json' with { type: 'json' };
// ============================================================================
// German Translations
// ============================================================================
import commonDe from './locales/de/common.json' with { type: 'json' };
import notificationsDe from './locales/de/notifications.json' with { type: 'json' };
import settingsDe from './locales/de/settings.json' with { type: 'json' };
import navDe from './locales/de/nav.json' with { type: 'json' };
import pagesDe from './locales/de/pages.json' with { type: 'json' };
import mobileDe from './locales/de/mobile.json' with { type: 'json' };
// ============================================================================
// Greek Translations
// ============================================================================
import commonEl from './locales/el/common.json' with { type: 'json' };
import notificationsEl from './locales/el/notifications.json' with { type: 'json' };
import settingsEl from './locales/el/settings.json' with { type: 'json' };
import navEl from './locales/el/nav.json' with { type: 'json' };
import pagesEl from './locales/el/pages.json' with { type: 'json' };
import mobileEl from './locales/el/mobile.json' with { type: 'json' };
// ============================================================================
// Spanish Translations
// ============================================================================
import commonEs from './locales/es/common.json' with { type: 'json' };
import notificationsEs from './locales/es/notifications.json' with { type: 'json' };
import settingsEs from './locales/es/settings.json' with { type: 'json' };
import navEs from './locales/es/nav.json' with { type: 'json' };
import pagesEs from './locales/es/pages.json' with { type: 'json' };
import mobileEs from './locales/es/mobile.json' with { type: 'json' };
// ============================================================================
// Finnish Translations
// ============================================================================
import commonFi from './locales/fi/common.json' with { type: 'json' };
import notificationsFi from './locales/fi/notifications.json' with { type: 'json' };
import settingsFi from './locales/fi/settings.json' with { type: 'json' };
import navFi from './locales/fi/nav.json' with { type: 'json' };
import pagesFi from './locales/fi/pages.json' with { type: 'json' };
import mobileFi from './locales/fi/mobile.json' with { type: 'json' };
// ============================================================================
// French Translations
// ============================================================================
import commonFr from './locales/fr/common.json' with { type: 'json' };
import notificationsFr from './locales/fr/notifications.json' with { type: 'json' };
import settingsFr from './locales/fr/settings.json' with { type: 'json' };
import navFr from './locales/fr/nav.json' with { type: 'json' };
import pagesFr from './locales/fr/pages.json' with { type: 'json' };
import mobileFr from './locales/fr/mobile.json' with { type: 'json' };
// ============================================================================
// Hebrew Translations
// ============================================================================
import commonHe from './locales/he/common.json' with { type: 'json' };
import notificationsHe from './locales/he/notifications.json' with { type: 'json' };
import settingsHe from './locales/he/settings.json' with { type: 'json' };
import navHe from './locales/he/nav.json' with { type: 'json' };
import pagesHe from './locales/he/pages.json' with { type: 'json' };
import mobileHe from './locales/he/mobile.json' with { type: 'json' };
// ============================================================================
// Hungarian Translations
// ============================================================================
import commonHu from './locales/hu/common.json' with { type: 'json' };
import notificationsHu from './locales/hu/notifications.json' with { type: 'json' };
import settingsHu from './locales/hu/settings.json' with { type: 'json' };
import navHu from './locales/hu/nav.json' with { type: 'json' };
import pagesHu from './locales/hu/pages.json' with { type: 'json' };
import mobileHu from './locales/hu/mobile.json' with { type: 'json' };
// ============================================================================
// Italian Translations
// ============================================================================
import commonIt from './locales/it/common.json' with { type: 'json' };
import notificationsIt from './locales/it/notifications.json' with { type: 'json' };
import settingsIt from './locales/it/settings.json' with { type: 'json' };
import navIt from './locales/it/nav.json' with { type: 'json' };
import pagesIt from './locales/it/pages.json' with { type: 'json' };
import mobileIt from './locales/it/mobile.json' with { type: 'json' };
// ============================================================================
// Japanese Translations
// ============================================================================
import commonJa from './locales/ja/common.json' with { type: 'json' };
import notificationsJa from './locales/ja/notifications.json' with { type: 'json' };
import settingsJa from './locales/ja/settings.json' with { type: 'json' };
import navJa from './locales/ja/nav.json' with { type: 'json' };
import pagesJa from './locales/ja/pages.json' with { type: 'json' };
import mobileJa from './locales/ja/mobile.json' with { type: 'json' };
// ============================================================================
// Korean Translations
// ============================================================================
import commonKo from './locales/ko/common.json' with { type: 'json' };
import notificationsKo from './locales/ko/notifications.json' with { type: 'json' };
import settingsKo from './locales/ko/settings.json' with { type: 'json' };
import navKo from './locales/ko/nav.json' with { type: 'json' };
import pagesKo from './locales/ko/pages.json' with { type: 'json' };
import mobileKo from './locales/ko/mobile.json' with { type: 'json' };
// ============================================================================
// Dutch Translations
// ============================================================================
import commonNl from './locales/nl/common.json' with { type: 'json' };
import notificationsNl from './locales/nl/notifications.json' with { type: 'json' };
import settingsNl from './locales/nl/settings.json' with { type: 'json' };
import navNl from './locales/nl/nav.json' with { type: 'json' };
import pagesNl from './locales/nl/pages.json' with { type: 'json' };
import mobileNl from './locales/nl/mobile.json' with { type: 'json' };
// ============================================================================
// Norwegian Translations
// ============================================================================
import commonNo from './locales/no/common.json' with { type: 'json' };
import notificationsNo from './locales/no/notifications.json' with { type: 'json' };
import settingsNo from './locales/no/settings.json' with { type: 'json' };
import navNo from './locales/no/nav.json' with { type: 'json' };
import pagesNo from './locales/no/pages.json' with { type: 'json' };
import mobileNo from './locales/no/mobile.json' with { type: 'json' };
// ============================================================================
// Polish Translations
// ============================================================================
import commonPl from './locales/pl/common.json' with { type: 'json' };
import notificationsPl from './locales/pl/notifications.json' with { type: 'json' };
import settingsPl from './locales/pl/settings.json' with { type: 'json' };
import navPl from './locales/pl/nav.json' with { type: 'json' };
import pagesPl from './locales/pl/pages.json' with { type: 'json' };
import mobilePl from './locales/pl/mobile.json' with { type: 'json' };
// ============================================================================
// Portuguese Translations
// ============================================================================
import commonPt from './locales/pt/common.json' with { type: 'json' };
import notificationsPt from './locales/pt/notifications.json' with { type: 'json' };
import settingsPt from './locales/pt/settings.json' with { type: 'json' };
import navPt from './locales/pt/nav.json' with { type: 'json' };
import pagesPt from './locales/pt/pages.json' with { type: 'json' };
import mobilePt from './locales/pt/mobile.json' with { type: 'json' };
// ============================================================================
// Romanian Translations
// ============================================================================
import commonRo from './locales/ro/common.json' with { type: 'json' };
import notificationsRo from './locales/ro/notifications.json' with { type: 'json' };
import settingsRo from './locales/ro/settings.json' with { type: 'json' };
import navRo from './locales/ro/nav.json' with { type: 'json' };
import pagesRo from './locales/ro/pages.json' with { type: 'json' };
import mobileRo from './locales/ro/mobile.json' with { type: 'json' };
// ============================================================================
// Russian Translations
// ============================================================================
import commonRu from './locales/ru/common.json' with { type: 'json' };
import notificationsRu from './locales/ru/notifications.json' with { type: 'json' };
import settingsRu from './locales/ru/settings.json' with { type: 'json' };
import navRu from './locales/ru/nav.json' with { type: 'json' };
import pagesRu from './locales/ru/pages.json' with { type: 'json' };
import mobileRu from './locales/ru/mobile.json' with { type: 'json' };
// ============================================================================
// Serbian Translations
// ============================================================================
import commonSr from './locales/sr/common.json' with { type: 'json' };
import notificationsSr from './locales/sr/notifications.json' with { type: 'json' };
import settingsSr from './locales/sr/settings.json' with { type: 'json' };
import navSr from './locales/sr/nav.json' with { type: 'json' };
import pagesSr from './locales/sr/pages.json' with { type: 'json' };
import mobileSr from './locales/sr/mobile.json' with { type: 'json' };
// ============================================================================
// Swedish Translations
// ============================================================================
import commonSv from './locales/sv/common.json' with { type: 'json' };
import notificationsSv from './locales/sv/notifications.json' with { type: 'json' };
import settingsSv from './locales/sv/settings.json' with { type: 'json' };
import navSv from './locales/sv/nav.json' with { type: 'json' };
import pagesSv from './locales/sv/pages.json' with { type: 'json' };
import mobileSv from './locales/sv/mobile.json' with { type: 'json' };
// ============================================================================
// Turkish Translations
// ============================================================================
import commonTr from './locales/tr/common.json' with { type: 'json' };
import notificationsTr from './locales/tr/notifications.json' with { type: 'json' };
import settingsTr from './locales/tr/settings.json' with { type: 'json' };
import navTr from './locales/tr/nav.json' with { type: 'json' };
import pagesTr from './locales/tr/pages.json' with { type: 'json' };
import mobileTr from './locales/tr/mobile.json' with { type: 'json' };
// ============================================================================
// Ukrainian Translations
// ============================================================================
import commonUk from './locales/uk/common.json' with { type: 'json' };
import notificationsUk from './locales/uk/notifications.json' with { type: 'json' };
import settingsUk from './locales/uk/settings.json' with { type: 'json' };
import navUk from './locales/uk/nav.json' with { type: 'json' };
import pagesUk from './locales/uk/pages.json' with { type: 'json' };
import mobileUk from './locales/uk/mobile.json' with { type: 'json' };
// ============================================================================
// Vietnamese Translations
// ============================================================================
import commonVi from './locales/vi/common.json' with { type: 'json' };
import notificationsVi from './locales/vi/notifications.json' with { type: 'json' };
import settingsVi from './locales/vi/settings.json' with { type: 'json' };
import navVi from './locales/vi/nav.json' with { type: 'json' };
import pagesVi from './locales/vi/pages.json' with { type: 'json' };
import mobileVi from './locales/vi/mobile.json' with { type: 'json' };
// ============================================================================
// Chinese Translations
// ============================================================================
import commonZh from './locales/zh/common.json' with { type: 'json' };
import notificationsZh from './locales/zh/notifications.json' with { type: 'json' };
import settingsZh from './locales/zh/settings.json' with { type: 'json' };
import navZh from './locales/zh/nav.json' with { type: 'json' };
import pagesZh from './locales/zh/pages.json' with { type: 'json' };
import mobileZh from './locales/zh/mobile.json' with { type: 'json' };
export const defaultNS = 'common';
export const namespaces = [
    'common',
    'notifications',
    'settings',
    'nav',
    'pages',
    'mobile',
];
export const resources = {
    en: {
        common: commonEn,
        notifications: notificationsEn,
        settings: settingsEn,
        nav: navEn,
        pages: pagesEn,
        mobile: mobileEn,
    },
    af: {
        common: commonAf,
        notifications: notificationsAf,
        settings: settingsAf,
        nav: navAf,
        pages: pagesAf,
        mobile: mobileAf,
    },
    ar: {
        common: commonAr,
        notifications: notificationsAr,
        settings: settingsAr,
        nav: navAr,
        pages: pagesAr,
        mobile: mobileAr,
    },
    ca: {
        common: commonCa,
        notifications: notificationsCa,
        settings: settingsCa,
        nav: navCa,
        pages: pagesCa,
        mobile: mobileCa,
    },
    cs: {
        common: commonCs,
        notifications: notificationsCs,
        settings: settingsCs,
        nav: navCs,
        pages: pagesCs,
        mobile: mobileCs,
    },
    da: {
        common: commonDa,
        notifications: notificationsDa,
        settings: settingsDa,
        nav: navDa,
        pages: pagesDa,
        mobile: mobileDa,
    },
    de: {
        common: commonDe,
        notifications: notificationsDe,
        settings: settingsDe,
        nav: navDe,
        pages: pagesDe,
        mobile: mobileDe,
    },
    el: {
        common: commonEl,
        notifications: notificationsEl,
        settings: settingsEl,
        nav: navEl,
        pages: pagesEl,
        mobile: mobileEl,
    },
    es: {
        common: commonEs,
        notifications: notificationsEs,
        settings: settingsEs,
        nav: navEs,
        pages: pagesEs,
        mobile: mobileEs,
    },
    fi: {
        common: commonFi,
        notifications: notificationsFi,
        settings: settingsFi,
        nav: navFi,
        pages: pagesFi,
        mobile: mobileFi,
    },
    fr: {
        common: commonFr,
        notifications: notificationsFr,
        settings: settingsFr,
        nav: navFr,
        pages: pagesFr,
        mobile: mobileFr,
    },
    he: {
        common: commonHe,
        notifications: notificationsHe,
        settings: settingsHe,
        nav: navHe,
        pages: pagesHe,
        mobile: mobileHe,
    },
    hu: {
        common: commonHu,
        notifications: notificationsHu,
        settings: settingsHu,
        nav: navHu,
        pages: pagesHu,
        mobile: mobileHu,
    },
    it: {
        common: commonIt,
        notifications: notificationsIt,
        settings: settingsIt,
        nav: navIt,
        pages: pagesIt,
        mobile: mobileIt,
    },
    ja: {
        common: commonJa,
        notifications: notificationsJa,
        settings: settingsJa,
        nav: navJa,
        pages: pagesJa,
        mobile: mobileJa,
    },
    ko: {
        common: commonKo,
        notifications: notificationsKo,
        settings: settingsKo,
        nav: navKo,
        pages: pagesKo,
        mobile: mobileKo,
    },
    nl: {
        common: commonNl,
        notifications: notificationsNl,
        settings: settingsNl,
        nav: navNl,
        pages: pagesNl,
        mobile: mobileNl,
    },
    no: {
        common: commonNo,
        notifications: notificationsNo,
        settings: settingsNo,
        nav: navNo,
        pages: pagesNo,
        mobile: mobileNo,
    },
    pl: {
        common: commonPl,
        notifications: notificationsPl,
        settings: settingsPl,
        nav: navPl,
        pages: pagesPl,
        mobile: mobilePl,
    },
    pt: {
        common: commonPt,
        notifications: notificationsPt,
        settings: settingsPt,
        nav: navPt,
        pages: pagesPt,
        mobile: mobilePt,
    },
    ro: {
        common: commonRo,
        notifications: notificationsRo,
        settings: settingsRo,
        nav: navRo,
        pages: pagesRo,
        mobile: mobileRo,
    },
    ru: {
        common: commonRu,
        notifications: notificationsRu,
        settings: settingsRu,
        nav: navRu,
        pages: pagesRu,
        mobile: mobileRu,
    },
    sr: {
        common: commonSr,
        notifications: notificationsSr,
        settings: settingsSr,
        nav: navSr,
        pages: pagesSr,
        mobile: mobileSr,
    },
    sv: {
        common: commonSv,
        notifications: notificationsSv,
        settings: settingsSv,
        nav: navSv,
        pages: pagesSv,
        mobile: mobileSv,
    },
    tr: {
        common: commonTr,
        notifications: notificationsTr,
        settings: settingsTr,
        nav: navTr,
        pages: pagesTr,
        mobile: mobileTr,
    },
    uk: {
        common: commonUk,
        notifications: notificationsUk,
        settings: settingsUk,
        nav: navUk,
        pages: pagesUk,
        mobile: mobileUk,
    },
    vi: {
        common: commonVi,
        notifications: notificationsVi,
        settings: settingsVi,
        nav: navVi,
        pages: pagesVi,
        mobile: mobileVi,
    },
    zh: {
        common: commonZh,
        notifications: notificationsZh,
        settings: settingsZh,
        nav: navZh,
        pages: pagesZh,
        mobile: mobileZh,
    },
};
export const supportedLanguages = Object.keys(resources);
export const defaultI18nConfig = {
    lng: 'en',
    fallbackLng: 'en',
    defaultNS,
    ns: namespaces,
    resources,
    interpolation: {
        escapeValue: false, // React already escapes values
    },
    // Returning the key is better than empty string for debugging
    returnNull: false,
    returnEmptyString: false,
};
// Prevents race conditions when initI18n is called concurrently
let initPromise = null;
export async function initI18n(options) {
    if (i18n.isInitialized) {
        return i18n;
    }
    if (initPromise) {
        return initPromise;
    }
    initPromise = i18n
        .use(initReactI18next)
        .init({
        ...defaultI18nConfig,
        ...options,
    })
        .then(() => {
        initPromise = null;
        return i18n;
    })
        .catch((error) => {
        initPromise = null;
        throw error;
    });
    return initPromise;
}
export { i18n };
//# sourceMappingURL=config.js.map